import { useState, useRef, useEffect, useContext } from 'react';

import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';

// material-ui
import AlertBar from 'ui-component/AlertBar';
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    Chip,
    ClickAwayListener,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Paper,
    Popper,
    Stack,
    Switch,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    MenuItem
} from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';
import User1 from 'assets/images/users/user-round.svg';

// assets
import { IconLogout, IconSettings, IconReplace, IconShieldCheck } from '@tabler/icons';

//auth0
import { useAuth0 } from '@auth0/auth0-react';
import AppContext from 'components/AppContext';

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
    if (isAuthenticated) {
        const { name, picture, email, role } = user;
    }
    const roles = user['https://maheerp.com/roles'];
    const isAdmin = roles.includes('Admin');

    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();

    const [sdm, setSdm] = useState(true);
    const [value, setValue] = useState('');
    const [notification, setNotification] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);
    const { isLoading, logout, loginWithRedirect } = useAuth0();
    const [trustDialogOpen, setTrustDialogOpen] = useState(false);
    const [deviceName, setDeviceName] = useState('');
    const [selectedUserId, setSelectedUserId] = useState('');
    const [users, setUsers] = useState([]);

    const [openmessageflag, setOpenMessageFlag] = useState(false);
    const [openmessagetext, setOpenMessageText] = useState('Success');
    const [openmessageseverity, setOpenMessageSeverity] = useState('success');

    function DisplayMessage(severity, text) {
        setOpenMessageFlag(true);
        setOpenMessageSeverity(severity);
        setOpenMessageText(text);
    }

    //Handle success/warning message close
    const handleMessageClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenMessageFlag(false);
    };

    const handleTrustDevice = () => {
        setTrustDialogOpen(true);
    };

    const handleCloseTrustDialog = () => {
        setTrustDialogOpen(false);
        setDeviceName('');
    };

    const handleLogout = async () => {
        // loginWithRedirect();
        logout({ returnTo: window.location.origin });
    };

    const handleUnitSelection = async () => {
        navigate('/', {
            replace: true
        });
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleListItemClick = (event, index, route = '') => {
        setSelectedIndex(index);
        handleClose(event);

        if (route && route !== '') {
            navigate(route);
        }
    };
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    useEffect(() => {
        if (trustDialogOpen) {
            const fetchUsers = async () => {
                try {
                    const token = await getAccessTokenSilently();
                    const res = await axios.get('/api/admin/users', {
                        headers: { authorization: `Bearer ${token}` }
                    });
                    setUsers(res.data);
                } catch (err) {
                    console.error('Failed to fetch users:', err);
                }
            };

            fetchUsers();
            setSelectedUserId('');
            setDeviceName('');
        }
    }, [trustDialogOpen, getAccessTokenSilently]);

    const myContext = useContext(AppContext);

    //Webcrypto start

    async function generateKeyPair() {
        try {
            const keyPair = await window.crypto.subtle.generateKey(
                { name: 'Ed25519' }, //'RSASSA-PKCS1-v1_5',
                false, //private key is NOT extractable
                ['sign', 'verify']
            );

            const spki = await window.crypto.subtle.exportKey('spki', keyPair.publicKey);

            //const publicKeyPem = bufferToPem(publicKeyBuffer, 'PUBLIC KEY');
            const pem = `-----BEGIN PUBLIC KEY-----\n${btoa(String.fromCharCode(...new Uint8Array(spki)))}\n-----END PUBLIC KEY-----`;
            // Store privateKey in IndexedDB (browser secure storage)
            await storePrivateKey(keyPair.privateKey);
            return { publicKeyPem: pem };
        } catch (err) {
            console.error('Error generating key pair:', err);
        }
    }

    function bufferToPem(buffer, label) {
        const base64 = btoa(String.fromCharCode(...new Uint8Array(buffer)));
        const formatted = base64.match(/.{1,64}/g).join('\n');
        return `-----BEGIN ${label}-----\n${formatted}\n-----END ${label}-----`;
    }

    async function storePrivateKey(privateKey) {
        return new Promise((resolve, reject) => {
            // Change version to 2
            const request = window.indexedDB.open('trustedDeviceDB', 2);

            request.onupgradeneeded = (event) => {
                const db = event.target.result;
                // This will now definitely run because the version is higher
                if (!db.objectStoreNames.contains('keys')) {
                    db.createObjectStore('keys');
                }
            };

            request.onsuccess = (event) => {
                const db = event.target.result;
                const tx = db.transaction('keys', 'readwrite');
                const store = tx.objectStore('keys');

                const putRequest = store.put({ privateKey, deviceName }, 'deviceEntry');
                //putRequest.onsuccess = () => resolve();
                putRequest.onerror = () => reject(new Error('Save failed'));
                // Success path: Close connection after transaction completes
                tx.oncomplete = () => {
                    db.close();
                    resolve();
                };
            };

            request.onerror = () => reject(new Error('DB Open failed'));
        });
    }
    //Web crypto end

    const handleConfirmTrustDevice = async () => {
        try {
            const token = await getAccessTokenSilently();
            const { publicKeyPem } = await generateKeyPair();

            await axios.post(
                '/api/admin/trustdevice',
                {
                    deviceName,
                    publicKey: publicKeyPem,
                    userId: selectedUserId //If you want admin user -- user.sub
                },
                {
                    headers: {
                        authorization: `Bearer ${token}`
                    }
                }
            );

            DisplayMessage('success', 'Device trusted successfully');
            handleCloseTrustDialog();
        } catch (err) {
            //console.error(err);
            DisplayMessage('error', 'Failed to trust device');
        }
    };

    return (
        <>
            <Chip
                sx={{
                    height: '48px',
                    alignItems: 'center',
                    borderRadius: '27px',
                    transition: 'all .3s ease-in-out',
                    borderColor: 'transparent',
                    background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.15)',
                    '&[aria-controls="menu-list-grow"], &:hover': {
                        borderColor: 'transparent',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: '#fff',
                        boxShadow: '0 4px 16px rgba(102, 126, 234, 0.4)',
                        transform: 'translateY(-2px)',
                        '& svg': {
                            stroke: '#fff'
                        },
                        '& .MuiAvatar-root': {
                            boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.3)'
                        }
                    },
                    '& .MuiChip-label': {
                        lineHeight: 0
                    }
                }}
                icon={
                    <Avatar
                        src={isAuthenticated ? user.picture : User1}
                        sx={{
                            ...theme.typography.mediumAvatar,
                            margin: '8px -15px 8px 8px !important',
                            cursor: 'pointer',
                            border: '2px solid rgba(255, 255, 255, 0.8)',
                            transition: 'all 0.3s ease'
                        }}
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        color="inherit"
                    />
                }
                // label={<IconSettings stroke={1.5} size="1.5rem" color={theme.palette.primary.main} />}
                variant="outlined"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                color="primary"
            />
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 14]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <Transitions in={open} {...TransitionProps}>
                        <Paper sx={{ zIndex: 999 }}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    <Box sx={{ pl: 2, pt: 2, mb: 0 }}>
                                        <Typography variant="h4">Hello, {isAuthenticated ? user.name : ''}</Typography>
                                    </Box>
                                    <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 250px)', overflowX: 'hidden' }}>
                                        <Box sx={{ pl: 1, mt: 0 }}>
                                            <List
                                                component="nav"
                                                sx={{
                                                    width: '100%',
                                                    maxWidth: 350,
                                                    minWidth: 300,
                                                    backgroundColor: theme.palette.background.paper,
                                                    borderRadius: '10px',
                                                    [theme.breakpoints.down('md')]: {
                                                        minWidth: '100%'
                                                    },
                                                    '& .MuiListItemButton-root': {
                                                        mt: 0.5
                                                    }
                                                }}
                                            >
                                                {isAuthenticated == true && (
                                                    <ListItemButton
                                                        sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                        selected={selectedIndex === 4}
                                                        onClick={handleUnitSelection}
                                                    >
                                                        <ListItemIcon>
                                                            <IconReplace stroke={1.5} size="1.3rem" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={<Typography variant="body2">Unit Selection</Typography>} />
                                                    </ListItemButton>
                                                )}
                                                {isAuthenticated == true && isAdmin && (
                                                    <ListItemButton
                                                        sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                        selected={selectedIndex === 4}
                                                        onClick={handleTrustDevice}
                                                    >
                                                        <ListItemIcon>
                                                            <IconShieldCheck stroke={1.5} size="1.3rem" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={<Typography variant="body2">Trust Device</Typography>} />
                                                    </ListItemButton>
                                                )}
                                                {isAuthenticated == true && (
                                                    <ListItemButton
                                                        sx={{ borderRadius: `${customization.borderRadius}px` }}
                                                        selected={selectedIndex === 4}
                                                        onClick={handleLogout}
                                                    >
                                                        <ListItemIcon>
                                                            <IconLogout stroke={1.5} size="1.3rem" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={<Typography variant="body2">Logout</Typography>} />
                                                    </ListItemButton>
                                                )}
                                            </List>
                                        </Box>
                                    </PerfectScrollbar>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Transitions>
                )}
            </Popper>

            <Dialog open={trustDialogOpen} onClose={handleCloseTrustDialog} maxWidth="xs" fullWidth>
                {' '}
                <DialogTitle fontSize="16px">Trust This Device</DialogTitle>{' '}
                <DialogContent>
                    {' '}
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        {' '}
                        Enter a name for this device. E.g. Vijay Desktop.{' '}
                    </Typography>{' '}
                    <TextField
                        select
                        label="Select User"
                        fullWidth
                        value={selectedUserId}
                        onChange={(e) => {
                            const chosenId = e.target.value;
                            setSelectedUserId(chosenId);

                            // Find the user object from your users array
                            const chosenUser = users.find((u) => u.user_id === chosenId);

                            // Update deviceName automatically to user.name (or email fallback)
                            if (chosenUser) {
                                setDeviceName(`${chosenUser.name || chosenUser.email} Desktop`);
                            }
                        }}
                    >
                        <MenuItem value="">Select User</MenuItem>
                        {users.map((user) => (
                            <MenuItem key={user.user_id} value={user.user_id}>
                                {user.name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        sx={{ mt: 2 }}
                        label="Device Name"
                        fullWidth
                        value={deviceName}
                        onChange={(e) => setDeviceName(e.target.value)}
                    />{' '}
                </DialogContent>{' '}
                <DialogActions>
                    {' '}
                    <Button onClick={handleCloseTrustDialog}>Cancel</Button>{' '}
                    <Button variant="contained" onClick={handleConfirmTrustDevice} disabled={!deviceName || !selectedUserId}>
                        {' '}
                        Trust Device{' '}
                    </Button>{' '}
                </DialogActions>{' '}
            </Dialog>

            {/* Alert section  */}
            {/* <AlertBar
                open={openmessageflag}
                message={openmessagetext}
                severity={openmessageseverity}
                closeHandler={handleMessageClose}
            ></AlertBar> */}
        </>
    );
};

export default ProfileSection;
